export default __webpack_public_path__ + "static/media/CFprofile.11a11f3a.webp";